import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import ServicePage from "@/pages/ServicePage";
import Projekte from "@/pages/Projekte";
import UeberUns from "@/pages/UeberUns";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

const NotFound = () => (
  <section className="flex min-h-[70vh] flex-col items-center justify-center bg-[#17251C] px-5 pt-32 text-center">
    <p className="eyebrow !text-[#DCCDB4]">404</p>
    <h1 className="display-xl mt-4 text-5xl text-[#F3EDE2] sm:text-7xl">Seite nicht gefunden.</h1>
    <Link to="/" className="btn-primary mt-8 !bg-[#F3EDE2] !text-[#17251C]" data-testid="notfound-home-link">
      Zur Startseite
    </Link>
  </section>
);

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/gartenbau" element={<ServicePage slug="gartenbau" />} />
            <Route path="/gartenplanung" element={<ServicePage slug="gartenplanung" />} />
            <Route path="/gartenpflege" element={<ServicePage slug="gartenpflege" />} />
            <Route
              path="/terrassen-pflasterarbeiten"
              element={<ServicePage slug="terrassen-pflasterarbeiten" />}
            />
            <Route path="/projekte" element={<Projekte />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <CookieBanner />
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
